export default [
  {
    path: '/knowledge/:key?',
    name: 'Knowledge',
    component: () => import('@/views/knowledge/Knowledge.vue'),
    meta: {},
  },
];
